<template>
  <div>
    <ul class="swatch-list">
      <li
        class="swatch-list__item"
        v-for="color in colorSwatches"
        :key="color.value"
      >
        <button
          :style="{ backgroundColor: color.value }"
          class="swatch-list__swatch"
          :class="{
            'swatch-list__swatch--selected':
              color.value.toLowerCase() === selectedSwatch.toLowerCase(),
            'swatch-list__swatch--border': color.value === '#ffffff',
          }"
          @click="selectColor(color.value)"
        >
          <span class="swatch-list__swatch-name">{{ color.value }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["selectedSwatch", "whichSwatch"],
  computed: {
    ...mapGetters("timers", ["colorSwatches"]),
  },
  methods: {
    selectColor(color) {
      this.$emit("update:color", { whichSwatch: this.whichSwatch, color });
    },
  },
};
</script>

<style scoped lang="scss">
.swatch-list {
  list-style: none outside;
  margin: 0;
  padding: 1em 1.5em;
  display: flex;
  flex-wrap: wrap;
  max-width: 300px;
  &__item {
    margin-left: 4px;
    margin-right: 4px;
    &:nth-child(14n + 1) {
      margin-left: 15px;
    }
  }
  &__swatch {
    border-radius: 100%;
    width: 26px;
    height: 26px;
    position: relative;
    &:before {
      content: "";
      border-radius: 100%;
      border: 4px solid #fff;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      opacity: 0;
    }
    &:after {
      border-radius: 100%;
      content: "";
      border: 2px solid #000;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      opacity: 0;
      outline: none;
    }
    &:hover,
    &:focus {
      outline: none;
      &:after {
        opacity: 1;
      }
    }
    &--border::after {
      opacity: 0.1;
    }
    &--selected {
      &:before {
        opacity: 1;
      }
      &:after {
        opacity: 1;
      }
    }
  }
  &__swatch-name {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
}
</style>
